<template>
    <div class="item-divider">
        <el-button type="text" class="remove-btn f-edit" @click="removeItem(ruleForm)"><span
                class="color-danger">删除</span>
        </el-button>
        <el-form :model="ruleForm" :rules="rules" :class="[{ 'form-view': !isEdit }, 'form-switch', 'form-col']"
                 ref="ruleForm"
                 label-width="100px">
            <div class="col-2 clearfix">
                <el-form-item label="职位技能:" prop="skill">
                    <p class="f-view" v-text="ruleForm.skill"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.skill" :maxlength="20"
                              placeholder="请输入职位技能"></el-input>
                </el-form-item>
                <el-form-item label="熟练度:" prop="proficiency">
                    <p class="f-view" v-text="getSelectMapText('WB_SKILL_PROFICIENCY', ruleForm.proficiency)"></p>
                    <el-select class="f-edit" v-model="ruleForm.proficiency"
                               placeholder="请选择熟练度">
                        <el-option
                                v-for="(item, index) in selectMap.WB_SKILL_PROFICIENCY"
                                :label="item.text"
                                :key="index"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="使用时间:" prop="experience">
                    <p class="f-view" v-text="getSelectMapText('WB_SKILL_YEARS', ruleForm.experience)"></p>
                    <el-select class="f-edit" v-model="ruleForm.experience"
                               placeholder="请选择使用时间">
                        <el-option
                                v-for="(item, index) in selectMap.WB_SKILL_YEARS"
                                :label="item.text"
                                :key="index"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
<script type="text/javascript">
    import multiItemMixin from './multiItemMixin'

    export default {
        mixins: [multiItemMixin],
        data () {
            return {
                ruleForm: this.init,
                resetData: Object.assign({}, this.init),
                rules: {
                    skill: [
                        {required: true, message: '请输入职位技能', trigger: 'blur'}
                    ],
                    experience: [
                        {required: true, message: '请选择使用时间', trigger: 'blur,change'}
                    ],
                    proficiency: [
                        {required: true, message: '请选择熟练度', trigger: 'blur,change'}
                    ]
                },
                isEdit: !(this.init.isEdit === false)
            }
        }
    }

</script>


// WEBPACK FOOTER //
// skill.vue?5909f73c